import { useCallback } from 'react';
import navStore from './navStore';

const useOffset = (width: number): ((currentSection: number) => number) => {
  const { linkWidth } = navStore(state => state.config);
  return useCallback(
    (currentSection: number) => {
      const halfWidth = width / 2;
      return currentSection > 0
        ? currentSection * linkWidth + linkWidth / 2 - halfWidth
        : 0;
    },
    [width, linkWidth]
  );
};

export default useOffset;
